import { render, staticRenderFns } from "./flugstrecken-vergleich-hinRueck.vue?vue&type=template&id=efed50d0&scoped=true"
import script from "./flugstrecken-vergleich-hinRueck.vue?vue&type=script&lang=js"
export * from "./flugstrecken-vergleich-hinRueck.vue?vue&type=script&lang=js"
import style0 from "./flugstrecken-vergleich-hinRueck.vue?vue&type=style&index=0&id=efed50d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efed50d0",
  null
  
)

export default component.exports